/**
 * Extract user-friendly error message from API or Error object.
 */
export function getErrorMessage(error, fallback = 'errors.generic') {
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  const message = error?.response?.data?.message
    || error?.response?.data?.error
    || error?.message;
  if (message && typeof message === 'string') return message;
  if (error?.response?.status === 401) return 'errors.unauthorized';
  if (error?.response?.status === 404) return 'errors.notFound';
  if (error?.response?.status >= 500 || error?.code === 'ERR_NETWORK') return 'errors.network';
  return fallback;
}
